import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { IOffer } from '@frontend/oxygen/core-utils';
import { from as observableFrom } from 'rxjs';

import { CommandService } from '../communication/command/command.service';
import { WindowRefService } from '../windowRef/window-ref.service';

@Injectable({ providedIn: 'root' })
export class BannerClickService {
    constructor(
        private router: Router,
        private windowRef: WindowRefService,
        private command: CommandService,
    ) {}

    public handleBannerClick($event: MouseEvent, offer: IOffer, redirect: boolean): void {
        this.generalMethods(offer.link!, offer.target!, redirect);
    }

    public handleFeaturedAemSlideClick(linkUrl: string, target: string): void {
        this.generalMethods(linkUrl, target, true);
    }

    private generalMethods(link: string, target: string, redirect: boolean): void {
        if (!link) {
            return;
        }
        const isExternalLink = link.startsWith('http') || target === '_blank' || link.indexOf('#!?') > -1;
        const betslip = this.parseBetslipIdFromLink(link);
        if (isExternalLink) {
            target === '_self' ? (this.windowRef.nativeWindow.location.href = link) : this.openBlankOption(link);
        } else {
            if (betslip.isBetslipLink) {
                observableFrom(
                    this.command.executeAsync(this.command.API.ADD_TO_BETSLIP_BY_OUTCOME_IDS, [betslip.betslipId, true, true, redirect]),
                ).subscribe();
            } else {
                this.router.navigateByUrl(link);
            }
        }
    }

    /**
     * Open url in new blank and
     * @param link
     */
    private openBlankOption(link: string) {
        let linkElement: HTMLAnchorElement | null = document.createElement('a');
        linkElement.href = link;
        linkElement.target = '_blank';
        linkElement.click();
        linkElement = null;
    }

    private parseBetslipIdFromLink(link: string): { isBetslipLink: boolean; betslipId: string | null } {
        const betslipObj: { isBetslipLink: boolean; betslipId: string | null } = {
            isBetslipLink: false,
            betslipId: null,
        };
        const betslipRegex = /betslip\/add\/(\d+(,\d+)*)/;
        const isBetslipLink = betslipRegex.test(link);
        if (isBetslipLink) {
            betslipObj.isBetslipLink = true;
            betslipObj.betslipId = link.match(betslipRegex)?.[1] || '';
        }
        return betslipObj;
    }
}
